/* ==========================================================================
   Twirl footer accordions — nested collapsibles.
   The FAQ row opens to reveal individually expandable questions, so an open
   panel releases its max-height and never clips a child.
   ========================================================================== */

(function () {
  'use strict';

  if (window.__twirlFooterAccordionsReady) return;
  window.__twirlFooterAccordionsReady = true;

  const panelOf = (toggle) => toggle.parentElement.querySelector('[data-twirl-facc-panel]');
  const glyphOf = (toggle) => toggle.querySelector('[data-twirl-facc-glyph]');

  function setGlyph(toggle, isOpen) {
    const glyph = glyphOf(toggle);
    if (glyph) glyph.textContent = isOpen ? '−' : '+';
  }

  /* Any open ancestor stops constraining once a child grows inside it. */
  function releaseAncestors(el) {
    let panel = el.parentElement && el.parentElement.closest('[data-twirl-facc-panel]');
    while (panel) {
      if (panel.style.maxHeight && panel.style.maxHeight !== '0px') {
        panel.style.maxHeight = 'none';
      }
      panel = panel.parentElement && panel.parentElement.closest('[data-twirl-facc-panel]');
    }
  }

  function close(toggle) {
    const panel = panelOf(toggle);
    if (!panel || toggle.getAttribute('aria-expanded') !== 'true') return;

    // Return from `none` to a measured height so the collapse animates.
    if (panel.style.maxHeight === 'none') panel.style.maxHeight = panel.scrollHeight + 'px';
    void panel.offsetHeight;

    toggle.setAttribute('aria-expanded', 'false');
    setGlyph(toggle, false);
    panel.style.maxHeight = '0px';
  }

  function open(toggle) {
    const panel = panelOf(toggle);
    if (!panel) return;

    toggle.setAttribute('aria-expanded', 'true');
    setGlyph(toggle, true);
    panel.style.maxHeight = panel.scrollHeight + 'px';
    releaseAncestors(panel);
  }

  function init() {
    document.querySelectorAll('[data-twirl-facc]').forEach((toggle) => {
      if (toggle.dataset.twirlFaccBound) return;
      toggle.dataset.twirlFaccBound = '1';

      const panel = panelOf(toggle);
      if (!panel) return;

      // Exclusivity is per level, so opening a question cannot close the
      // FAQ row that contains it.
      const group = toggle.closest('[data-twirl-facc-group]');

      toggle.addEventListener('click', () => {
        const isOpen = toggle.getAttribute('aria-expanded') === 'true';

        if (group) {
          group.querySelectorAll('[data-twirl-facc]').forEach((other) => {
            if (other === toggle) return;
            if (other.closest('[data-twirl-facc-group]') !== group) return;
            close(other);
          });
        }

        if (isOpen) close(toggle);
        else open(toggle);
      });

      panel.addEventListener('transitionend', (event) => {
        if (event.propertyName !== 'max-height' || event.target !== panel) return;
        if (toggle.getAttribute('aria-expanded') === 'true') panel.style.maxHeight = 'none';
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
